<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="学生档案修改设置" :visible.sync="dialogVisible" width="1000px">
        <span>
             <el-form>
                <div style="width: 100%" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'meetShape'" class="field">是否允许修改学生档案</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                         <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="是否允许修改" rules="required">
                                            <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="paramsObj.type">
                                                    <el-radio :label="1">允许</el-radio>
                                                    <el-radio :label="2">指定时间允许</el-radio>
                                                    <el-radio :label="0">不允许</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="paramsObj.type!=0">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'meetShape'" class="field">修改权限适用范围</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                         <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="适用范围" rules="required">
                                            <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="paramsObj.role">
                                                    <el-radio :label="3">学生及教师</el-radio>
                                                    <el-radio :label="4">仅教师</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="paramsObj.type==2">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'meetShape'" class="field">允许修改时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                          <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="允许修改时间" rules="required">
                                            <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-date-picker v-model="paramsObj.startTime" value-format="yyyy-MM-dd" type="date" placeholder="选择开始日期" :picker-options="startPickerOptions"> </el-date-picker>
                                            </el-tooltip>
                                            <span style="display: inline-block;margin:0 10px;">至</span>
                                            <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-date-picker v-model="paramsObj.endTime" value-format="yyyy-MM-dd" type="date" placeholder="选择结束日期" :picker-options="endPickerOptions"> </el-date-picker>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <!-- <tr v-if="paramsObj.type==2">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'meetShape'" class="field">允许修改结束时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                           <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="允许修改结束时间" rules="required">
                                            <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-date-picker v-model="paramsObj.endTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="endPickerOptions"> </el-date-picker>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="confirmClick">保 存</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            loginUser: this.$store.getters.loginUser,
            paramsObj: {
                // id: '',
                // type: 1,
                // startTime: '',
                // endTime: ''
            }
        }
    },
    computed: {
        startPickerOptions() {
            return {
                disabledDate: (date) => {
                // 获取今天0点的时间戳
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    const todayTime = today.getTime()

                    // 当前遍历的日期时间戳
                    const time = date.getTime()

                    // 情况1: 日期在今天之前 → 禁用
                    const isBeforeToday = time < todayTime

                    // 情况2: 日期在结束时间之后 → 禁用 (如果已设置结束时间)
                    let isAfterEnd = false
                    if (this.paramsObj.endTime) {
                        const endDate = new Date(this.paramsObj.endTime)
                        endDate.setHours(0, 0, 0, 0)
                        isAfterEnd = time > endDate.getTime()
                    }

                    return isBeforeToday || isAfterEnd
                }
            }
        },
        endPickerOptions() {
            return {
                disabledDate: (date) => {
                    // 获取今天0点的时间戳
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    const todayTime = today.getTime()

                    // 当前遍历的日期时间戳
                    const time = date.getTime()

                    // 情况1: 日期在今天之前 → 禁用
                    const isBeforeToday = time < todayTime

                    // 情况2: 日期在开始时间之前 → 禁用 (如果已设置开始时间)
                    let isBeforeStart = false
                    if (this.paramsObj.startTime) {
                        const startDate = new Date(this.paramsObj.startTime)
                        startDate.setHours(0, 0, 0, 0)
                        isBeforeStart = time < startDate.getTime()
                    }
                    return isBeforeToday || isBeforeStart
                }
            }
        }
    },
    created() {
        this.$bus.on('openEditInfoDialog', this.openEditInfoDialog)
    },
    beforeDestroy() {
        this.$bus.off('openEditInfoDialog', this.openEditInfoDialog)
    },
    methods: {
        openEditInfoDialog() {
            this.dialogVisible = true
            this.getConfig()
        },
        async getConfig() {
            const param = [
                { 'compare': '=', 'field': 'orgCode', 'merge': true, 'value': this.loginUser.orgCode },
                { 'compare': '=', 'field': 'paramName', 'merge': true, 'value': 'student.edit.info' }
            ]
            const rest = await this.$app.querydata('base/paramConfig/querydata', param)
            if (rest.code === 'success') {
                // 格式：0_2025-05-01_2025-05-30。注：1允许，不限时间 2允许，指定时间 0禁止
                if (!rest.body.listdata.length) {
                    this.$set(this.paramsObj, 'type', 1)
                    return
                } else {
                    this.paramsObj = rest.body.listdata[0]
                    let paramsArr = this.paramsObj.paramValue.split('_')
                    if (paramsArr.length) {
                        this.$set(this.paramsObj, 'type', Number(paramsArr[0]))
                        if (paramsArr[0] === '1' || paramsArr[0] === '0') {
                            this.$set(this.paramsObj, 'role', Number(paramsArr[1]))
                        } else {
                            this.$set(this.paramsObj, 'role', Number(paramsArr[3]))
                        }
                        if (paramsArr[0] === '2') {
                            this.$set(this.paramsObj, 'startTime', paramsArr[1])
                            this.$set(this.paramsObj, 'endTime', paramsArr[2])
                        }
                    }
                }
            }
        },
        confirmClick() {
            this.formValidate(() => {
                if (!this.paramsObj.id) {
                    this.dialogVisible = false
                    this.$message.success('保存成功')
                    return
                }
                if (this.paramsObj.type === 2) {
                    this.paramsObj.paramValue = '2_' + this.paramsObj.startTime + '_' + this.paramsObj.endTime + '_' + this.paramsObj.role
                } else {
                    this.paramsObj.paramValue = this.paramsObj.type + '_' + this.paramsObj.role
                }
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/base/paramConfig/update`,
                    method: 'PUT',
                    data: this.paramsObj
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success('保存成功')
                        this.dialogVisible = false
                    }
                })
            }, null, 1)
        }
    }
}
</script>

<style>

</style>
